import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class BillingInvoiceDownload extends BaseModel {
  /**
   * @var {string}
   */
  downloadUrl;

  /**
   * @var {string}
   */
  object;

  /**
   * @var {number}
   */
  validTill;

  constructor(model = {}) {
    super();

    this.downloadUrl = model.downloadUrl;
    this.object = model.object;
    this.validTill = model.validTill;
  }
}
